import { render } from "./ChatBubble.vue?vue&type=template&id=4069f60b&scoped=true&ts=true"
import script from "./ChatBubble.vue?vue&type=script&lang=ts"
export * from "./ChatBubble.vue?vue&type=script&lang=ts"

import "./ChatBubble.vue?vue&type=style&index=0&id=4069f60b&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4069f60b"]])

export default __exports__